
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue'
import VueRouter from 'vue-router'

import store from './store'

import Base from './components/Base'
import Api from './api.js';
import utl from './utl.js';

import router from './router.js';
Vue.use(VueRouter);

// Other systems
window.Event = new Vue;
window.api = new Api();
window.TITLE_END = ' - Configaro';

Vue.mixin(utl);

// Global components
import SimpleForm from './components/SimpleForm';
Vue.component('SimpleForm',SimpleForm)


// Launch
const app = new Vue({
	el: '#APP',
	template: '<Base />',
	components: { Base },
	store,
	router,
});
